const apps = [
    {name: "default", msg: "You are not assigned to this app in Okta.", contact: ""},
    {name: "seedware", msg: "You are not set up for automatic sign-in to SeedWare with Corteva", contact: "the_resource@agresource.ca"}
]

export default {
  getCustomErrorMsg(name) {
    if (name) {
      return apps.filter(app => app.name === name)[0]
    } else {
      return apps[0]
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/custom-error.js